export const SIGNUP_SOURCE = Object.freeze({
  CHECKOUT: 'Checkout',
  MY_ACCOUNT: 'MyAccount',
  FOOTER: 'Footer',
  PREFERENCE_CENTER: 'Preference center',
  REGISTER: 'Register',
  POPUP: 'Popup',
  PRODUCT_REGISTRATION: 'Product registration',
  STANDALONE_NEWSLETTER: 'Standalone newsletter',
});

export const SIGNUP_SOURCE_CART = Object.freeze({
  SHOPPING_CART: 'Shopping Cart',
  SPARE_PARTS_LIST: 'Spare Parts List',
  KEYS_AND_LOCKS_LIST: 'Keys And Locks List',
  PRODUCT_DETAIL_PAGE: 'Product Detail Page',
  BUNDLE_PRODUCT_DETAIL_PAGE: 'Bundle Product Detail Page',
  UPSELL: 'Upsell',
});

export const SIGNUP_SOURCE_IDENTITY = Object.freeze({
  LOGIN: 'Login',
  REGISTER: 'Register',
  PRODUCT_REGISTRATION: 'Product Registration',
  CHECKOUT: 'Checkout',
  CHECKOUT_NEWSLETTER_SIGNUP: 'Checkout Newsletter Signup',
  CHECKOUT_LOGIN: 'Checkout Login',
  CHECKOUT_PAYMENT_NEWSLETTER_SIGNUP: 'Checkout Payment Newsletter Signup',
  CHECKOUT_SHIPPING: 'Checkout Shipping',
  CHECKOUT_KLARNA: 'Checkout Klarna',
  MY_ACCOUNT_SHIPPING: 'My Account Shipping',
  FOOTER_NEWSLETTER_SIGNUP: 'Footer Newsletter Signup',
  POPUP_NEWSLETTER_SIGNUP: 'Popup Newsletter Signup',
  PREFERENCE_CENTER: 'Preference Center',
  NOTIFY_ME: 'Notify Me',
  INTERESTS: 'Interests',
  STANDALONE_NEWSLETTER_SIGNUP: 'Standalone Newsletter Signup',
});
